/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-plusplus */
/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable no-restricted-syntax */
import Payment from 'payment';
import confetti from 'canvas-confetti';
import { messages } from '.';

export const triggerConfetti = (options = {}) => {
  try {
    if (typeof window !== 'undefined') {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 9999,
        ...options,
      });
    }
  } catch (e) {
    // ignore
  }
};

export const regex = {
  plate: /[a-zA-Z]{3}\d[\da-jA-J]\d{2}/,
  chassis: /^[a-zA-Z\d]+/,
  document: /^\d*$/
};

export const extract = {
  sensitiveFields: ['password'],
  normalize: (value) => value?.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
  onlyNumbers: (value) => value?.replace(/[^\d]/g, ''),
  onlyAlpha: (value) => value?.replace(/[^a-zA-Z]/g, ''),
  onlyAlphaAndNumbers: (value) => value?.replace(/[^\da-zA-Z]/g, ''),
  userName: (name) => {
    if (!name) { return ''; }
    const parts = name.split(' ');
    let user = '';
    for (const part of parts) {
      user += part;
      if (user.length > 5) { break; }
      user += ' ';
    }
    return name.length < 5 ? name : user;
  },
  user: (user) => {
    if (!user) { return null; }
    const obj = {};
    Object.keys(user).forEach((key) => {
      if (!extract.sensitiveFields.includes(key)) {
        obj[key] = user[key];
      }
    });
    return obj;
  },
  userAddress: (address) => {
    if (!address) { return 'N/D'; }
    const parts = [];
    if (address.street) {
      parts.push(address.street);
    }
    if (address.number) {
      parts.push(`, ${address.number}`);
    }
    if (address.complement) {
      parts.push(` - ${address.complement}`);
    }
    if (address.neighborhood) {
      parts.push(` - ${address.neighborhood}`);
    }
    if (address.city) {
      parts.push(` - ${address.city}`);
    }
    if (address.state) {
      parts.push(`/${address.state}`);
    }
    if (address.postalCode) {
      parts.push(` - CEP: ${address.postalCode}`);
    }
    return parts.join('');
  },
  checked: (value) => (typeof value !== 'undefined' ? value : false),
  history: {
    value: (item) => item.plate || item.chassis || item.document || item.number || item.generic
  },
  inquiry: {
    value: (item) => item.plate || item.chassis || item.document || item.number || item.generic
  },
  product: {
    name: (item) => {
      if (item.generic) {
        return `Genérico (${item.generic.name})`;
      }
      if (item.product) {
        return item.product.name;
      }
      return item.inquiry ? item.inquiry.name : item.inquiry;
    },
    value: (item) => {
      if (item.product) {
        return item.product.value;
      }
      return item.inquiry ? item.inquiry.value : '';
    },
  },
  inquiries: {
    customer: (types, home, testDrive) => {
      const inquiries = {
        ...types,
      };
      if (testDrive) {
        delete inquiries.testDrive;
        delete inquiries.cyberMonday;
        delete inquiries.blackFriday;
      }
      if (home) {
        Object.keys(inquiries).forEach((key) => {
          if (!inquiries[key].home) {
            delete inquiries[key];
          }
        });
      } else {
        Object.keys(inquiries).forEach((key) => {
          if (inquiries[key].partner || inquiries[key].ignore) {
            delete inquiries[key];
          }
        });
      }
      return inquiries;
    },
    partner: (types) => {
      const inquiries = {
        ...types,
      };
      delete inquiries.testDrive;
      Object.keys(inquiries).forEach((key) => {
        if (inquiries[key].customer) {
          delete inquiries[key];
        }
      });
      return inquiries;
    },
  },
  errorMessage: (item) => {
    const ND = 'N/D';
    if (item.error !== ND) {
      try {
        const json = JSON.parse(item.error);
        if (typeof json === 'object') {
          if (json.message) {
            return json.message;
          }
        }
      } catch (e) { /* empty */ }
      return item.error;
    }
    const value = item.result;
    if (!value) {
      return ND;
    }
    if (value.data?.data) {
      return value.data.data.message;
    }
    if (value.body?.error) {
      return value.body.error.msg;
    }
    if (value.body?.duplicity_checking) {
      return value.body.duplicity_checking;
    }
    if (value.data?.data?.body?.error) {
      return value.data.data.body.error.msg;
    }
    if (value.RESPOSTA) {
      return value.RESPOSTA.ERRO || value.RESPOSTA.MensagemRF || (value.RESPOSTA.binXML ? value.RESPOSTA.binXML.situacao : '');
    }
    if (value.CRLVE) {
      return value.CRLVE.mensagem;
    }
    if (value.json?.NewDataSet?.Retorno?.Mensagem) {
      return value.json.NewDataSet.Retorno.Mensagem;
    }
    if (value.json?.ReportPJResponseEx?.Response?.Header?.Message) {
      return value.json.ReportPJResponseEx.Response.Header.Message;
    }
    if (value.json?.QuodReportResponseEx?.Response?.Header?.Message) {
      return value.json.QuodReportResponseEx.Response.Header.Message;
    }
    if (value.pesquisa) {
      return value.pesquisa.ERRO;
    }
    if (value.message) {
      if (value.message === 'API: {}' || value.message.indexOf('<mensagem>') === -1) {
        return ND;
      }
      return value.message.substring(value.message.indexOf('<mensagem>') + 10, value.message.indexOf('</mensagem>'));
    }
    if (value.data) {
      const error = JSON.stringify(value.data);
      if (error.indexOf('<mensagem>') === -1) {
        return ND;
      }
      return error.substring(error.indexOf('<mensagem>') + 10, error.indexOf('</mensagem>'));
    }
    return ND;
  },
  jwt: {
    payload: (token) => {
      try {
        return JSON.parse(Buffer.from(token.split('.')[1], 'base64'));
      } catch (e) {
        return null;
      }
    },
  },
};

export const format = {
  currency: (value, cents) => {
    if (value && value.toString().indexOf('R$') !== -1) {
      return value;
    }
    if (typeof value === 'undefined' || value === null) {
      return 'N/D';
    }
    value = parseFloat(cents ? `${value.toString().substring(0, value.toString().length - 2)}.${value.toString().substring(value.toString().length - 2)}` : value).toFixed(2) + '';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  },
  number: (value) => {
    if (typeof value === 'undefined' || value === null) {
      return 'N/D';
    }
    return parseInt(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
    });
  },
  document: (value) => {
    if (!value) {
      return value;
    }
    const document = value.split(';')[0];
    if (document.length === 14) {
      return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    if (document.length === 11) {
      return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return document || 'N/D';
  },
  maskDocument: (value) => {
    if (!value) return '***';
    const cleaned = value.toString().replace(/\D+/g, '');
    if (cleaned.length === 11) {
      return `***.***.${cleaned.substring(6, 9)}-**`;
    }
    if (cleaned.length === 14) {
      return `**.***.${cleaned.substring(5, 8)}/${cleaned.substring(8, 12)}-**`;
    }
    return '***.***.***-**';
  },
  clearNumber: (value = '') => value.replace(/\D+/g, ''),
  creditCardNumber: (value) => {
    if (!value) {
      return value;
    }

    const issuer = Payment.fns.cardType(value);
    const clearValue = format.clearNumber(value);
    let nextValue;

    switch (issuer) {
      case 'amex':
        nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10,)} ${clearValue.slice(10, 15)}`;
        break;
      case 'dinersclub':
        nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10,)} ${clearValue.slice(10, 14)}`;
        break;
      default:
        nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 8,)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 19)}`;
        break;
    }

    return nextValue.trim();
  },
  cvc: (value, prevValue, allValues = {}) => {
    const clearValue = format.clearNumber(value);
    let maxLength = 4;

    if (allValues.number) {
      const issuer = Payment.fns.cardType(allValues.number);
      maxLength = issuer === 'amex' ? 4 : 3;
    }

    return clearValue.slice(0, maxLength);
  },
  expirationDate: (value) => {
    const clearValue = format.clearNumber(value);

    if (clearValue.length >= 3) {
      return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
    }

    return clearValue;
  },
  formData: (data) => Object.keys(data).map((d) => `${d}: ${data[d]}`),
  date: (base, time) => {
    const convertUTCDateToLocalDate = (date) => {
      const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
      const offset = date.getTimezoneOffset() / 60;
      const hours = date.getHours();
      newDate.setHours(hours - offset);
      return newDate;
    };
    const value = (base ? convertUTCDateToLocalDate(new Date(base)) : new Date());
    return value.toISOString().substring(0, time ? 19 : 10);
  },
  dateBr: (base) => {
    const value = base || new Date();
    let month = (value.getMonth() + 1) + '';
    if ((value.getMonth() + 1) < 10) {
      month = `0${month}`;
    }
    const day = value.getDate() < 10 ? `0${value.getDate()}` : value.getDate();
    return `${day}/${month}/${value.getFullYear()}`;
  },
  date2: (base) => {
    if (!base) { return 'N/D'; }
    if (base.indexOf('-') !== -1) {
      const parts = base.split('-');
      if (parts.length > 1) {
        return `${parts[2].split('T')[0]}/${parts[1]}/${parts[0]}`;
      }
    }
    if (typeof base === 'string' && base.indexOf('/') === -1) {
      return `${base.substring(6, 8)}/${base.substring(4, 6)}/${base.substring(0, 4)}`;
    }
    return base;
  },
  dateUs: (base) => {
    if (!base) {
      return 'N/D';
    }
    const parts = base.split('/');
    if (parts.length > 1) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return base;
  },
  dateTime: (date) => new Date(date).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).replace(',', ''),
  dateTimeShort: (date) => new Date(date).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }).replace(',', ''),
  capitalize: (text) => {
    if (!text) {
      return '';
    }
    const skip = ['e', 'de', 'da', 'do', 'dos', 'um', 'uma', 'uns', 'umas'];
    const parts = text.toLowerCase().split(' ');
    parts.forEach((element, index) => {
      if (skip.indexOf(element) !== -1) {
        return;
      }
      if (['sa', 's.a.', 'ltda', 'ltda.', 'me', 'me.', '-me', 'eireli'].indexOf(element) !== -1) {
        parts[index] = element.toUpperCase();
        return;
      }
      parts[index] = element.substring(0, 1).toUpperCase() + element.substring(1);
    });
    return parts.join(' ').trim();
  },
  upper: (value) => {
    if (!value) {
      return value;
    }
    return value.toUpperCase();
  },
  mobile: (number) => {
    if (!number) {
      return 'N/D';
    }
    const value = number.replace(/[\s()-]/g, '');
    if (value.length === 8) {
      return `${value.substring(0, 4)}-${value.substring(4)}`;
    }
    if (value.length === 9) {
      return `${value.substring(0, 5)}-${value.substring(5)}`;
    }
    if (value.length === 10) {
      return `(${value.substring(0, 2)}) ${value.substring(2, 6)}-${value.substring(6)}`;
    }
    if (value.length === 11) {
      return `(${value.substring(0, 2)}) ${value.substring(2, 7)}-${value.substring(7)}`;
    }
    if (value.length === 12) {
      return `(${value.substring(2, 4)}) ${value.substring(4, 8)}-${value.substring(8)}`;
    }
    if (value.length === 13) {
      return `(${value.substring(2, 4)}) ${value.substring(4, 9)}-${value.substring(9)}`;
    }
    return 'N/D';
  },
};

export const date = {
  diff: {
    seconds: (start, end) => Math.round((end.getTime() - start.getTime()) / 1000),
    minutes: (start, end) => Math.round((end.getTime() - start.getTime()) / 1000 / 60),
    hours: (start, end) => Math.round((end.getTime() - start.getTime()) / 1000 / 60 / 60),
    days: (start, end) => Math.round((end.getTime() - start.getTime()) / 1000 / 60 / 60 / 24),
  },
  convert: (value) => {
    if (value.indexOf('/') !== -1) {
      const parts = value.split('/');
      return parseInt(`${parts[2]}${parts[1]}${parts[0]}`);
    }
    if (value.indexOf('-') !== -1) {
      const parts = value.split('-');
      return parseInt(`${parts[2]}${parts[1]}${parts[0]}`);
    }
    return 0;
  },
  truncate: (base) => {
    if (!base) { return null; }
    const month = base.getMonth() + 1;
    const day = base.getDate() < 10 ? `0${base.getDate()}` : base.getDate();
    const monthFixed = month < 10 ? `0${month}` : month;
    return `${base.getFullYear()}-${monthFixed}-${day}`;
  },
};

export const fetcher = (url) => fetch(url).then((r) => {
  if (r.ok) {
    return r.json();
  }
  return {};
});

export const profile = {
  defaultPicture: (id) => `https://avatar.tobi.sh/${id}`,
  canManager: (user) => {
    if (!user?.roles) {
      return false;
    }
    return profile.isManager(user) || profile.isSeller(user);
  },
  isManager: (user) => {
    if (!user?.roles) {
      return false;
    }
    return user.roles.indexOf('MANAGER') !== -1 || profile.isAdmin(user);
  },
  isLeads: (user) => {
    if (!user?.roles) {
      return false;
    }
    return user.roles.indexOf('LEADS') !== -1;
  },
  isSeller: (user) => {
    if (!user?.roles) {
      return false;
    }
    return user.roles.indexOf('SELLER') !== -1 || profile.isAdmin(user);
  },
  isAdmin: (user) => {
    if (!user?.roles) {
      return false;
    }
    return user.roles.indexOf('ADMIN') !== -1;
  },
  hasRole: (user, roles) => {
    if (!user?.roles) {
      return false;
    }
    return user.roles.some((role) => roles.indexOf(role) !== -1);
  },
};

export const editor = {
  json: {
    translations: {
      ITEM_SINGLE: '{{count}} item',
      ITEMS_MULTIPLE: '{{count}} itens',
      KEY_NEW: 'Digite a chave',
      ERROR_KEY_EXISTS: 'Chave já existe',
      ERROR_INVALID_JSON: 'JSON Inválido',
      ERROR_UPDATE: 'Atualizado com sucesso',
      ERROR_DELETE: 'Removido com sucesso',
      ERROR_ADD: 'Adicionado com sucesso',
      DEFAULT_STRING: 'Novo dado',
      DEFAULT_NEW_KEY: 'chave',
    }
  }
};

export const validate = {
  plate: (value) => {
    if (value.match(regex.plate)) {
      return true;
    }
    messages.info('<strong>Placa com formato inválido!</strong><br/>Por favor, informe a placa no formato correto.<br/><br/>Exemplo: <li><b>AAA9999</b> - Formato Antigo</li><li><b>AAA9J99</b> - Formato Mercosul</li>', false, true);
    return false;
  },
  cpf: (cpf) => {
    if (typeof cpf !== 'string') return false;
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;
    cpf = cpf.split('');
    const validator = cpf
      .filter((digit, index, array) => index >= array.length - 2 && digit)
      .map((el) => +el);
    const toValidate = (pop) => cpf
      .filter((digit, index, array) => index < array.length - pop && digit)
      .map((el) => +el);
    const rest = (count, pop) => (toValidate(pop)
      .reduce((soma, el, i) => soma + el * (count - i), 0) * 10) % 11 % 10;
    return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]);
  },
  cnpj: (value) => {
    if (!value) return false;
    value = value.replace(/[^\d]+/g, '');
    if (value.length !== 14 || !!value.match(/(\d)\1{10}/)) return false;
    const match = value.toString().match(/\d/g);
    const numbers = Array.isArray(match) ? match.map(Number) : [];
    if (numbers.length !== 14) return false;
    const items = [...new Set(numbers)];
    if (items.length === 1) return false;
    const calc = (x) => {
      const slice = numbers.slice(0, x);
      let factor = x - 7;
      let sum = 0;
      for (let i = x; i >= 1; i--) {
        const n = slice[x - i];
        sum += n * factor--;
        if (factor < 2) factor = 9;
      }
      const result = 11 - (sum % 11);
      return result > 9 ? 0 : result;
    };
    const digits = numbers.slice(12);
    const digit0 = calc(12);
    if (digit0 !== digits[0]) return false;
    const digit1 = calc(13);
    return digit1 === digits[1];
  },
  email: (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  document: (value) => {
    if (!value) return false;
    const clean = value.toString().replace(/\D+/g, '');
    if (clean.length === 11) return validate.cpf(clean);
    if (clean.length === 14) return validate.cnpj(clean);
    return false;
  },
};

export const pdf = {
  open: (base64Data, title) => {
    const pdfWindow = window.open('');
    pdfWindow.document.write(`<html<head><meta charSet="utf-8" /><title>${title}</title><link rel="icon" type="image/png" href="https://aboutcar.com.br/assets/images/favicon.png" /><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>`);
    pdfWindow.document.write(`<body><embed width="100%" height="100%" mode="show_pdf" src="data:application/pdf;base64,${base64Data}#toolbar=0&navpanes=0&scrollbar=0"></embed></body></html>`);
  },
};

export const image = {
  open: (base64Data, title, mimeType) => {
    const opener = window.open('', title);
    opener.document.write(`<html<head><meta charSet="utf-8" /><title>${title}</title><link rel="icon" type="image/png" href="https://aboutcar.com.br/assets/images/favicon.png" /><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>`);
    opener.document.write(`<body><img src="data:${mimeType || 'image/png'};base64,${base64Data}#toolbar=0&navpanes=0&scrollbar=0" width="100%" /></body></html>`);
  },
};

export const generator = {
  number: () => Math.floor(10000 + Math.random() * 90000),
  rand: () => Math.random().toString(36).substring(2),
  token: () => generator.rand() + generator.rand(),
};

export const sort = {
  byName: (a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  },
  byValue: (a, b) => {
    if (a.value < b.value) {
      return -1;
    }
    if (a.value > b.value) {
      return 1;
    }
    return 0;
  },
  products: (a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  },
  productItems: (a, b) => {
    if (a.sync) {
      return -1;
    }
    if (!b.sync) {
      return 1;
    }
    return 0;
  },
};

export const group = {
  products: (products, ignore) => {
    const groups = [];
    const items = ignore ? products.filter((el) => !el.operation && !el.aux) : products;
    items.sort(sort.products).forEach((currentProduct) => {
      if (currentProduct.aux) {
        let aux = groups.find((el) => el.name === 'Auxiliar');
        if (!aux) {
          aux = { name: 'Auxiliar', products: [] };
          groups.push(aux);
        }
        aux.products.push(currentProduct);
      } else if (currentProduct.operation) {
        let operation = groups.find((el) => el.name === 'Operação');
        if (!operation) {
          operation = { name: 'Operação', products: [] };
          groups.push(operation);
        }
        operation.products.push(currentProduct);
      } else if (currentProduct.home || (currentProduct.category === 'VEHICLE' && !currentProduct.partner)) {
        let site = groups.find((el) => el.name === 'Site');
        if (!site) {
          site = { name: 'Site', products: [] };
          groups.push(site);
        }
        site.products.push(currentProduct);
      } else if (currentProduct.partner) {
        let partner = groups.find((el) => el.name === 'Parceiro');
        if (!partner) {
          partner = { name: 'Parceiro', products: [] };
          groups.push(partner);
        }
        partner.products.push(currentProduct);
      } else if (currentProduct.category === 'CUSTOM') {
        let custom = groups.find((el) => el.name === 'Personalizado');
        if (!custom) {
          custom = { name: 'Personalizado', products: [] };
          groups.push(custom);
        }
        custom.products.push(currentProduct);
      }
    });
    return groups;
  },
};

export const clipboard = {
  copy: (value, callback) => {
    if (value) {
      navigator.clipboard.writeText(value);
      callback(value);
    }
  },
  paste: (callback) => {
    navigator.clipboard.readText().then((text) => {
      callback(text);
    });
  },
};

export const ref = {
  files: {
    check: (ref) => {
      return ref.current?.files?.length > 0;
    }
  }
}

export const images = {
  sign: 'data:image/png;base64,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',
};
